export default __webpack_public_path__ + "static/media/news5.cca5991c.webp";